/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const Status = {
  Running: "running",
  Stopped: "stopped",
  All: "all",
} as const;
export type Status = ClosedEnum<typeof Status>;

export const GetApiV3MetricsRegisteredCanistersCountFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3MetricsRegisteredCanistersCountFormat = ClosedEnum<
  typeof GetApiV3MetricsRegisteredCanistersCountFormat
>;

export type GetApiV3MetricsRegisteredCanistersCountRequest = {
  status?: Array<Status> | undefined;
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * Subnet ID
   */
  subnet?: string | null | undefined;
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3MetricsRegisteredCanistersCountFormat | undefined;
  /**
   * Step value
   */
  step?: number | undefined;
};

/** @internal */
export const Status$inboundSchema: z.ZodNativeEnum<typeof Status> = z
  .nativeEnum(Status);

/** @internal */
export const Status$outboundSchema: z.ZodNativeEnum<typeof Status> =
  Status$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace Status$ {
  /** @deprecated use `Status$inboundSchema` instead. */
  export const inboundSchema = Status$inboundSchema;
  /** @deprecated use `Status$outboundSchema` instead. */
  export const outboundSchema = Status$outboundSchema;
}

/** @internal */
export const GetApiV3MetricsRegisteredCanistersCountFormat$inboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsRegisteredCanistersCountFormat> = z
    .nativeEnum(GetApiV3MetricsRegisteredCanistersCountFormat);

/** @internal */
export const GetApiV3MetricsRegisteredCanistersCountFormat$outboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsRegisteredCanistersCountFormat> =
    GetApiV3MetricsRegisteredCanistersCountFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsRegisteredCanistersCountFormat$ {
  /** @deprecated use `GetApiV3MetricsRegisteredCanistersCountFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsRegisteredCanistersCountFormat$inboundSchema;
  /** @deprecated use `GetApiV3MetricsRegisteredCanistersCountFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsRegisteredCanistersCountFormat$outboundSchema;
}

/** @internal */
export const GetApiV3MetricsRegisteredCanistersCountRequest$inboundSchema:
  z.ZodType<
    GetApiV3MetricsRegisteredCanistersCountRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    status: z.array(Status$inboundSchema).optional(),
    start: z.nullable(z.number()).default(null),
    subnet: z.nullable(z.string()).default(null),
    end: z.nullable(z.number()).default(null),
    format: GetApiV3MetricsRegisteredCanistersCountFormat$inboundSchema.default(
      "json",
    ),
    step: z.number().int().default(7200),
  });

/** @internal */
export type GetApiV3MetricsRegisteredCanistersCountRequest$Outbound = {
  status?: Array<string> | undefined;
  start: number | null;
  subnet: string | null;
  end: number | null;
  format: string;
  step: number;
};

/** @internal */
export const GetApiV3MetricsRegisteredCanistersCountRequest$outboundSchema:
  z.ZodType<
    GetApiV3MetricsRegisteredCanistersCountRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3MetricsRegisteredCanistersCountRequest
  > = z.object({
    status: z.array(Status$outboundSchema).optional(),
    start: z.nullable(z.number()).default(null),
    subnet: z.nullable(z.string()).default(null),
    end: z.nullable(z.number()).default(null),
    format: GetApiV3MetricsRegisteredCanistersCountFormat$outboundSchema
      .default("json"),
    step: z.number().int().default(7200),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsRegisteredCanistersCountRequest$ {
  /** @deprecated use `GetApiV3MetricsRegisteredCanistersCountRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsRegisteredCanistersCountRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsRegisteredCanistersCountRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsRegisteredCanistersCountRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsRegisteredCanistersCountRequest$Outbound` instead. */
  export type Outbound =
    GetApiV3MetricsRegisteredCanistersCountRequest$Outbound;
}

export function getApiV3MetricsRegisteredCanistersCountRequestToJSON(
  getApiV3MetricsRegisteredCanistersCountRequest:
    GetApiV3MetricsRegisteredCanistersCountRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsRegisteredCanistersCountRequest$outboundSchema.parse(
      getApiV3MetricsRegisteredCanistersCountRequest,
    ),
  );
}

export function getApiV3MetricsRegisteredCanistersCountRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3MetricsRegisteredCanistersCountRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsRegisteredCanistersCountRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3MetricsRegisteredCanistersCountRequest' from JSON`,
  );
}
